import { usePersistedState } from './usePersistedState';

type PersistedSort = {
  order: 'asc' | 'desc';
  orderBy: string;
};

/**
 * A DataTable's column sort, persisted across visits. DataTable stays
 * uncontrolled — this only supplies its initial `defaultOrder`/`defaultOrderBy`
 * (read once, on mount, already restored) and listens for further changes
 * through `onSortChange` to keep the persisted copy current.
 *
 * @example
 * const { order, orderBy, onSortChange } = usePersistedSort('contractors:sort', 'desc', 'createdDate');
 * <DataTable defaultOrder={order} defaultOrderBy={orderBy} onSortChange={onSortChange} ... />
 */
export const usePersistedSort = (key: string, defaultOrder: 'asc' | 'desc', defaultOrderBy: string) => {
  const [sort, setSort] = usePersistedState<PersistedSort>(key, { order: defaultOrder, orderBy: defaultOrderBy });

  const onSortChange = (order: 'asc' | 'desc', orderBy: string) => {
    setSort({ order, orderBy });
  };

  return { order: sort.order, orderBy: sort.orderBy, onSortChange };
};
